import { render, staticRenderFns } from "./exhibition-business-match.vue?vue&type=template&id=eff3bf6e&scoped=true&"
import script from "./exhibition-business-match.vue?vue&type=script&lang=js&"
export * from "./exhibition-business-match.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-business-match.vue?vue&type=style&index=0&id=eff3bf6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff3bf6e",
  null
  
)

export default component.exports